import React from 'react';
import { cn } from '@/lib/utils';

export const AlternateModalHeader = ({ children, className }: React.BaseHTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn([
      'flex p-4 items-start self-stretch text-[14px] font-bold',
      'border-0 border-b border-solid border-b-venn-grey-40 bg-venn-grey-20',
      className,
    ])}
  >
    {children}
  </div>
);
